import { FC, MutableRefObject, useRef, useState, useEffect } from 'react';
import { getLabel } from '../autocompleteUtils';
import { autocomplete } from '../searchAutocomplete.api';
import { AutocompleteItemType } from '../searchAutocomplete.types';
import useIsMounted from '../../../../../components/useIsMounted';

type Props = {
  query: string;
  isLoggedIn: boolean;
  children: (data: { items: Array<AutocompleteItemType> }) => ReturnType<FC>;
};

export const SearchAutocompleteFetcher: FC<Props> = ({
  query,
  isLoggedIn,
  children,
}) => {
  const isMounted = useIsMounted();

  /**
   * Prevent previous autocomplete requests to override new ones
   */
  const requestIndex: MutableRefObject<number> = useRef(0);
  const lastResponseIndex: MutableRefObject<number> = useRef(0);

  const [items, setItems] = useState<Array<AutocompleteItemType>>([]);

  useEffect(() => {
    if (query.length > 0 || isLoggedIn) {
      requestIndex.current += 1;
      autocomplete(query, requestIndex.current)
        .then(response => {
          const responseIndex = response.data.index;

          if (responseIndex < lastResponseIndex.current) {
            return;
          }
          lastResponseIndex.current = responseIndex;

          const newItems = response.data.completions.map(item => ({
            ...item,
            label: getLabel(item),
          }));
          if (isMounted) {
            setItems(newItems);
          } else {
            console.log('not mounted');
          }
        })
        .catch(error => {
          console.error(error);
          if (isMounted) {
            setItems([]);
          }
        });
    }
  }, [query, isLoggedIn]);

  return children({ items });
};
